// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gyramais-information .information-skeleton {
  margin-top: 0.3rem;
  width: 100% !important;
}
.gyramais-information .information-title-container {
  margin-bottom: 0.2rem;
}
.gyramais-information .value-area {
  display: flex;
  align-items: center;
}
.gyramais-information .value-area > span {
  display: block;
  overflow-x: hidden;
  text-overflow: ellipsis;
}
.gyramais-information .value-area .information-input {
  min-height: 0 !important;
  padding: 0 !important;
  border-radius: 0;
  border-top: none;
  border-left: none;
  border-right: none;
  font-size: 1.5rem;
  line-height: 1.8rem;
  color: #000;
}
.gyramais-information .value-area .information-input:focus {
  box-shadow: none;
}
@media (max-width: 768px) {
  .gyramais-information .value-area .information-input {
    font-size: 1.2rem;
    line-height: 1.5rem;
  }
}
.gyramais-information .information-value {
  display: block;
  width: 100%;
}
.gyramais-information .information-value .value-wrapper {
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}
.gyramais-information .information-value .value-wrapper .original-promo-item {
  text-decoration: line-through;
  font-size: 1rem;
  line-height: 1rem;
  margin-right: 0.3rem;
  color: var(--danger-color);
}
.gyramais-information.danger .information-value {
  color: var(--danger-color) !important;
}
.gyramais-information.danger .information-value span {
  color: var(--danger-color) !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/gyramais/Information/styles.less"],"names":[],"mappings":"AAAA;EAEI,kBAAA;EACA,sBAAA;AAAJ;AAHA;EAOI,qBAAA;AADJ;AANA;EAWI,aAAA;EACA,mBAAA;AAFJ;AAVA;EAeM,cAAA;EACA,kBAAA;EACA,uBAAA;AAFN;AAfA;EAqBM,wBAAA;EACA,qBAAA;EAEA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EAMA,iBAAA;EACA,mBAAA;EACA,WAAA;AATN;AAGM;EACE,gBAAA;AADR;AAQM;EAAA;IACE,iBAAA;IACA,mBAAA;EALN;AACF;AAnCA;EA6CI,cAAA;EACA,WAAA;AAPJ;AAvCA;EAiDM,gBAAA;EACA,uBAAA;EACA,cAAA;AAPN;AA5CA;EAsDQ,6BAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,0BAAA;AAPR;AAYE;EAEI,qCAAA;AAXN;AASE;EAKM,qCAAA;AAXR","sourcesContent":[".gyramais-information {\n  .information-skeleton {\n    margin-top: 0.3rem;\n    width: 100% !important;\n  }\n\n  .information-title-container {\n    margin-bottom: 0.2rem;\n  }\n\n  .value-area {\n    display: flex;\n    align-items: center;\n\n    > span {\n      display: block;\n      overflow-x: hidden;\n      text-overflow: ellipsis;\n    }\n\n    .information-input {\n      min-height: 0 !important;\n      padding: 0 !important;\n\n      border-radius: 0;\n      border-top: none;\n      border-left: none;\n      border-right: none;\n\n      &:focus {\n        box-shadow: none;\n      }\n\n      font-size: 1.5rem;\n      line-height: 1.8rem;\n      color: #000;\n\n      @media (max-width: @md-screen) {\n        font-size: 1.2rem;\n        line-height: 1.5rem;\n      }\n    }\n  }\n\n  .information-value {\n    display: block;\n    width: 100%;\n\n    .value-wrapper {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      display: block;\n\n      .original-promo-item {\n        text-decoration: line-through;\n        font-size: 1rem;\n        line-height: 1rem;\n        margin-right: 0.3rem;\n        color: var(--danger-color);\n      }\n    }\n  }\n\n  &.danger {\n    .information-value {\n      color: var(--danger-color) !important;\n\n      span {\n        color: var(--danger-color) !important;\n      }\n    }\n  }\n}\n\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
